import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import Buttons from "./Shared/Button";

export const ConformationModal = ({
  show,
  onHide,
  onPrimary,
  onSecondary,
  showSecondary,
  primaryText,
  secondaryText,
  title,
  bodyText,
  inputFields, // Array of input field configs: [{ name: 'fieldName', label: 'Field Label', type: 'text', placeholder: '', required: true, value: '' }]
  onInputChange, // Callback for when input values change
  formData, // Object containing form field values
}) => {
  const [localFormData, setLocalFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    // Initialize local form data with provided formData or default values
    if (inputFields) {
      const initialData = {};
      inputFields.forEach(field => {
        initialData[field.name] = formData?.[field.name] || field.value || '';
      });
      setLocalFormData(initialData);
    }
  }, [inputFields, formData, show]);

  const handleInputChange = (fieldName, value) => {
    const updatedData = { ...localFormData, [fieldName]: value };
    setLocalFormData(updatedData);

    // Clear validation error for this field
    if (validationErrors[fieldName]) {
      setValidationErrors(prev => ({ ...prev, [fieldName]: null }));
    }

    if (onInputChange) {
      onInputChange(updatedData);
    }
  };

  const validateForm = () => {
    if (!inputFields) return true;

    const errors = {};
    inputFields.forEach(field => {
      if (field.required && !localFormData[field.name]?.trim()) {
        errors[field.name] = `${field.label} is required`;
      }
      // Email validation
      if (field.type === 'email' && localFormData[field.name]) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(localFormData[field.name])) {
          errors[field.name] = 'Please enter a valid email address';
        }
      }
    });

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handlePrimaryClick = () => {
    if (inputFields) {
      if (!validateForm()) {
        return;
      }
      if (onPrimary) onPrimary(localFormData);
    } else {
      if (onPrimary) onPrimary();
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => onHide()}
      centered
      className="confirm-modal"
    >
      <div className="message-container custome-msg-container">
        <div
          className="message-header-box"
          style={{ backgroundColor: "#dc3545" }}
        >
          <h4>{title}</h4>
        </div>
        <div className="message-body">
          {bodyText && <p>{bodyText}</p>}
          {inputFields && inputFields.length > 0 && (
            <Form>
              {inputFields.map((field, index) => (
                <Form.Group key={index} className="mb-3">
                  <Form.Label>
                    {field.label}
                    {field.required && <span className="text-danger"> *</span>}
                  </Form.Label>
                  <Form.Control
                    type={field.type || 'text'}
                    placeholder={field.placeholder || ''}
                    value={localFormData[field.name] || ''}
                    onChange={(e) => handleInputChange(field.name, e.target.value)}
                    isInvalid={!!validationErrors[field.name]}
                  />
                  {validationErrors[field.name] && (
                    <Form.Control.Feedback type="invalid">
                      {validationErrors[field.name]}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              ))}
            </Form>
          )}
        </div>
        <div className="message-footer pt-0">
          <Buttons
            variant="danger"
            title={primaryText ? primaryText : "Yes"}
            type="submit"
            size="xs"
            color="white"
            onClick={handlePrimaryClick}
          ></Buttons>
          {true === showSecondary && (
            <Buttons
              variant="secondary"
              title={secondaryText ? secondaryText : "No"}
              type="submit"
              size="xs"
              color="white"
              onClick={() => {
                if (onSecondary) onSecondary();
              }}
            ></Buttons>
          )}
        </div>
      </div>
    </Modal>
  );
};
